<template>
  <div id="app">
    <Sprite></Sprite>
    <Responsive :breakpoints="breakpoints">
      <Quiz></Quiz>
      <Map></Map>
    </Responsive>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite.vue'
import Quiz from '@/components/Quiz/Quiz.vue'
import Map from '@/components/Map/Map.vue'
import breakpoints from '@/ulils/responsive.breakpoints'

export default {
  name: 'App',
  components: {
    Sprite,
    Map,
    Quiz,
  },
  data () {
    return { breakpoints }
  },
  mounted () {
    const pairs = window.location.search.replace('?', '').split('&')
    const opts = pairs.reduce((acc, pair) => {
      const [field, value] = pair.split('=')
      acc[field] = value
      return acc
    }, {})
    opts.speed && this.$store.commit('_set', ['carSpeed', Number(opts.speed)])
  },
}
</script>
